    <template>
    <div class="pad20">
       
        <div class="opportunity_sec" v-if="checkProperty(petition,'attornyOrAgentInfo','entityType')=='Attorney'">
            <div class="vx-row blockmargin main-list-panel">
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'firstName')">
                    <div class="main-list">
                        <p>
                            First Name
                            <span>{{checkProperty(attorneyDetails,'firstName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'middleName')">
                    <div class="main-list">
                        <p>
                            Middle Name
                            <span>{{checkProperty(attorneyDetails,'middleName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'lastName')">
                    <div class="main-list">
                        <p>
                            Last Name
                            <span>{{checkProperty(attorneyDetails,'lastName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'email')">
                    <div class="main-list">
                        <p>
                            Email
                            <span>{{checkProperty(attorneyDetails,'email')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'phone')">
                    <div class="main-list">
                        <p>
                            Phone
                            <span>
                            <template v-if="checkProperty(attorneyDetails ,'phoneCountryCode' ,'countryCallingCode')">{{checkProperty(attorneyDetails ,'phoneCountryCode' ,'countryCallingCode')+"&nbsp;"}}</template>
                            {{attorneyDetails.phone | formatPhone}}
    
                        </span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'busEmail')">
                    <div class="main-list">
                        <p>
                           Business Email
                            <span>{{checkProperty(attorneyDetails,'busEmail')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'busName')">
                    <div class="main-list">
                        <p>
                            Business Name
                            <span>{{checkProperty(attorneyDetails,'busName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(attorneyDetails,'busEIN')">
                    <div class="main-list">
                        <p>
                            Business FEIN
                            <span>{{checkProperty(attorneyDetails,'busEIN')}}</span>
                        </p>
                    </div>
                </div>
            </div>    
            <template v-if="checkProperty(attorneyDetails ,'address')">
                <div class="devider w-full"></div>
                <div class="vx-row m-0 main-list-panel">
                    <h5 class="names_title">Address</h5>
                    <div class="dependent-block_wrap address_info_wrap">
                    <div class="vx-col  w-full p-0" >
                        <div class="main-list">
                    <p>
    
                        <span v-html="$options.filters.addressformat(attorneyDetails.address)"></span>
    
                    </p>
                        </div>
                    </div>
                    
                </div>
                </div>
            </template>
        </div>
        <div class="opportunity_sec" v-if="checkProperty(petition,'attornyOrAgentInfo','entityType')=='Agent'">
            <div class="vx-row blockmargin main-list-panel">
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'firstName')">
                    <div class="main-list">
                        <p>
                            First Name
                            <span>{{checkProperty(agentDetails,'firstName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'middleName')">
                    <div class="main-list">
                        <p>
                            Middle Name
                            <span>{{checkProperty(agentDetails,'middleName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'lastName')">
                    <div class="main-list">
                        <p>
                            Last Name
                            <span>{{checkProperty(agentDetails,'lastName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'email')">
                    <div class="main-list">
                        <p>
                            Email
                            <span>{{checkProperty(agentDetails,'email')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'phone')">
                    <div class="main-list">
                        <p>
                            Phone
                            <span>
                            <template v-if="checkProperty(agentDetails ,'phoneCountryCode' ,'countryCallingCode')">{{checkProperty(agentDetails ,'phoneCountryCode' ,'countryCallingCode')+"&nbsp;"}}</template>
                            {{agentDetails.phone | formatPhone}}
    
                        </span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'busEmail')">
                    <div class="main-list">
                        <p>
                           Business Email
                            <span>{{checkProperty(agentDetails,'busEmail')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'busName')">
                    <div class="main-list">
                        <p>
                            Business Name
                            <span>{{checkProperty(agentDetails,'busName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full" v-if="checkProperty(agentDetails,'busEIN')">
                    <div class="main-list">
                        <p>
                            Business FEIN
                            <span>{{checkProperty(agentDetails,'busEIN')}}</span>
                        </p>
                    </div>
                </div>
            </div>    
            <template v-if="checkProperty(agentDetails ,'address')">
                <div class="devider w-full"></div>
                <div class="vx-row m-0 main-list-panel">
                    <h5 class="names_title">Address</h5>
                    <div class="dependent-block_wrap address_info_wrap">
                    
                    <div class="vx-col  w-full p-0" >
                        <div class="main-list">
                    <p>
    
                        <span v-html="$options.filters.addressformat(agentDetails.address)"></span>
    
                    </p>
                        </div>
                    </div>
                </div>
                </div>
            </template>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        data: () => ({
            attorneyDetails:null,
            agentDetails:null
        }),
        props: {
            petition: {
                type: Object,
                default: null
            },
            visastatuses: {
                type: Array,
                default: null
            }
        },
        computed: {
            showRouteName(){
                if(this.$route.name == 'questionnaire'){
                    return false
                }
                else{
                    return true
                }
            }
        },
        mounted(){
            if(this.checkProperty(this.petition,'attornyOrAgentInfo') && this.checkProperty(this.petition,'attornyOrAgentInfo','attorneyDetails')){
                this.attorneyDetails = this.checkProperty(this.petition,'attornyOrAgentInfo','attorneyDetails');
            }
            if(this.checkProperty(this.petition,'attornyOrAgentInfo') && this.checkProperty(this.petition,'attornyOrAgentInfo','agentInfo')){
                this.agentDetails = this.checkProperty(this.petition,'attornyOrAgentInfo','agentInfo');
            }
        }
    };
    </script>
    